import React, { useState } from 'react';

export default function OptionGroup({ title, children, defaultOpen = true, id, icon, description, badge }) {
  const [open, setOpen] = useState(defaultOpen);
  const rich = Boolean(icon || description);

  return (
    <section id={id} className={`tpb-option-group${open ? ' is-open' : ''}${rich ? ' tpb-option-group--rich' : ''}`}>
      <button
        type="button"
        className="tpb-option-group-toggle"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {rich ? (
          <>
            {icon && <span className="tpb-option-group-icon"><i className={icon} aria-hidden="true" /></span>}
            <span className="tpb-option-group-text">
              <strong>{title}</strong>
              {description && <small>{description}</small>}
            </span>
            {badge != null && <span className="tpb-option-group-badge">{badge}</span>}
            <i className={`fas fa-chevron-${open ? 'up' : 'down'} tpb-option-group-chevron`} aria-hidden="true" />
          </>
        ) : (
          <>
            <i className={`fas fa-chevron-${open ? 'down' : 'right'}`} aria-hidden="true" />
            {title}
          </>
        )}
      </button>
      {open && <div className="tpb-option-group-body">{children}</div>}
    </section>
  );
}
